<template>
  <div id="hytzs">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'hytzs'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/member/notice/Hytzs.vue